import { Typography } from '@mui/material';
import axios from 'axios'
import React, { useEffect, useState } from 'react';
import AppCard from "../components/AppCard";
import { model, fblink } from '../config/config';

function ZeppWF() {
 
  const [content, setContent] = useState([]);
 

  const fetchApps = async () => {
    const { data } = await axios.get(
      `${fblink}/zeppwf/${model}.json?orderBy="fileid"&limitToLast=500`
    );
	let arrayOfObjects = Object.keys(data).map(key => {
		let ar = data[key]
		ar.key = key
		return ar})
		
		arrayOfObjects.shift();
		
		arrayOfObjects.sort((a, b) => b.fileid - a.fileid);
		
        setContent(arrayOfObjects);
    
	
  }
  useEffect(() => {
    fetchApps();
  }, [])
  
  return (
    <div className='container' style={{ padding: "64px 1vw 64px 1vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
       Zepp Standard Watchface - Amazfit {model.toUpperCase()}
      </Typography>
	
	{ content.length !== 0 ?	
      (<div className="card-grid">
        {
          content && content.map(item => {
            return <AppCard key={item.fileid} {...item} binfile="watchface" />
          })
        }
      </div>)
	  :
	  (
	  <Typography variant="h5" component="h6" mb={4}>
      
      </Typography>
	)
	}
      
    </div>
  )
}

export default ZeppWF